// extracted by mini-css-extract-plugin
export default {"title__section":"Title_title__section__94T3h"};